import React from 'react';
import RichText from 'components/RichText';
import WistiaVideo from 'components/Core/WistiaVideo';
import WebsiteImage from 'components/WebsiteImage';
import InPageFeaturesCtaButton from './InPageFeaturesCtaButton';
import richTextOptions from './richTextOptions';
import { FeaturedContentInnerContainer, RichTextContainer } from './styles';

const InPageFeaturesV3FeaturedContent = ({ item }) => {
  const { link, linkLabel, featuredImage, featuredVideo, description } = item || {};

  const itemType =
    featuredImage?.image?.file?.contentType === 'video/mp4' ||
    featuredImage?.bynderDesktopImage?.[0]?.videoPreviewURLs?.[0]?.endsWith('mp4')
      ? 'mp4'
      : item?.featuredVideo
      ? 'wistiaVideo'
      : 'image';

  const featuredContent =
    itemType === 'image' ? (
      <FeaturedContentInnerContainer
        style={{
          maxHeight: '100%',
          backgroundImage: `url(${
            featuredImage?.bynderDesktopImage?.[0]?.thumbnails?.src ||
            featuredImage?.image?.file?.url
          })`,
        }}
      />
    ) : itemType === 'mp4' ? (
      <FeaturedContentInnerContainer>
        <WebsiteImage {...featuredImage} />
      </FeaturedContentInnerContainer>
    ) : (
      <WistiaVideo dataPosition="In-Page Features" url={featuredVideo?.sharableLink} />
    );

  return (
    <>
      {featuredContent}
      <RichTextContainer>
        <RichText content={description} options={richTextOptions} />
        {link && <InPageFeaturesCtaButton to={link} label={linkLabel || 'Learn More'} />}
      </RichTextContainer>
    </>
  );
};

export default InPageFeaturesV3FeaturedContent;
